import {
  faBars,
  faChevronLeft,
  faChevronRight,
  faMoon,
  faRightFromBracket,
  faSun,
  faTriangleExclamation,
  faUser,
  faUsersGear,
} from '@fortawesome/free-solid-svg-icons';

/**
 * The shell's icon vocabulary. CUAM stays on FontAwesome (issue #492, ADR-0022), so these are
 * `IconDefinition` objects. Duplicated from the webapp's `theme/icons.ts` — the two packages share
 * no source module.
 *
 * Every glyph mui-appshell renders itself has to be supplied as a node: a string is read as a
 * Material Symbols ligature and CUAM ships no such webfont, so a missed one renders as literal text.
 */
export const icons = {
  bars: faBars,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  moon: faMoon,
  signOut: faRightFromBracket,
  sun: faSun,
  user: faUser,
  usersGear: faUsersGear,
  warning: faTriangleExclamation,
} as const;
